import { ClueSolvingSubBehaviour } from "../ClueSolvingSubBehaviour";
import { PuzzleModal } from "./PuzzleModal";
export class AbstractPuzzleSolving extends ClueSolvingSubBehaviour {
    constructor(name, parent, puzzle, autostart, modal_title, settings_id) {
        super(name, parent, "clue");
        this.puzzle = puzzle;
        this.autostart = autostart;
        this.modal_title = modal_title;
        this.settings_id = settings_id;
    }
    async resetProcess(start) {
        if (this.process) {
            this.process.stop();
            this.process = null;
        }
        if (start) {
            this.process = await this.constructProcess();
            this.process.puzzle_closed.on(() => this.endClue("Puzzle Process reported a closed puzzle"));
            this.process.start();
        }
        this.modal.update();
    }
    begin() {
        this.modal = new PuzzleModal(this);
        this.modal.title.set(this.modal_title);
        this.modal.hidden.on(() => this.endClue("Puzzle Modal hidden"));
        this.modal.show();
        if (this.autostart)
            this.resetProcess(true);
    }
    end() {
        this.resetProcess(false);
        this.modal.remove();
    }
}
